<template>
    <div>
        <van-tabbar v-model="active" @change="onTabChange">
            <van-tabbar-item name="home" icon="home-o">首页</van-tabbar-item>
            <van-tabbar-item name="news" icon="new-o">新闻</van-tabbar-item>
            <!--<van-tabbar-item name="gem" icon="apps-o">场馆</van-tabbar-item>-->
            <van-tabbar-item name="mine" icon="friends-o">我的</van-tabbar-item>
        </van-tabbar>
        <div v-if="active==='home'" class="page">
            <van-swipe :autoplay="2000"  indicator-color="#fff" class="banner-area">
                <van-swipe-item v-for="(image, index) in bannerList" :key="index">
                    <img :src="image.pictureUrl" class="banner-image">
                </van-swipe-item>
            </van-swipe>
            <van-row class="notice-area" @click="gotoNoticeCenter">
                <van-col span="2" style="height: 41px;display: flex;align-items: center">
                    <img src="../assets/notice_icon.png" style="width:14px;height: 13px;margin-left: 13px;">
                </van-col>
                <van-col span="22" style="height: 41px;display: flex;align-items: center">
                    <van-swipe :autoplay="2000" vertical loop  :show-indicators="false" style="height: 41px;">
                        <van-swipe-item v-for="(item, index) in noticeList" :key="index" style="display: flex;justify-content: space-between;align-items: center">
                            <div class="van-ellipsis font-12 color-black font-weight" style="margin-left: 7px;margin-right: 10px;">{{item.title}}</div>
                            <van-col class="van-ellipsis font-12 color-gray" style="height: 41px;display: flex;align-items: center">{{item.createdate}}</van-col>
                        </van-swipe-item>
                    </van-swipe>
                </van-col>

            </van-row>
            <van-row type="flex" justify="space-around">
                <van-col v-for="(item, index) in funtionList" :key="index" @click="gotoPage(index)">
                    <div style="display: flex;justify-content: center;flex-direction: column;">
                        <img src="../assets/one.png" v-if="index==0" style="width:60px;height: 60px;border-radius: 50%;"/>
                        <img src="../assets/two.png" v-if="index==1" style="width:60px;height: 60px;border-radius: 50%;"/>
                        <img src="../assets/three.png" v-if="index==2" style="width:60px;height: 60px;border-radius: 50%;"/>
                        <img src="../assets/four.png" v-if="index==3" style="width:60px;height: 60px;border-radius: 50%;"/>
                        <img src="../assets/five.png" v-if="index==4" style="width:60px;height: 60px;border-radius: 50%;"/>
                        <div class="fuc-name">{{item.name}}</div>
                    </div>
                </van-col>
            </van-row>
            <van-row class="news-top">
                <van-col>
                    <div class="news_left"></div>
                </van-col>
                <van-col>
                    <div class="news_text">新闻中心</div>
                </van-col>
            </van-row>
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad"
            >
                <van-cell v-for="item in newsList" :key="item" style="padding: 0;" @click="gotoNewsDetail(item.id,item.newsUrl)">
                    <div class="one-pic-news" v-if="item.imgList.length<3">
                        <van-row >
                            <van-col span="24">
                                <van-row>
                                    <div class="big-news-title" style="margin-bottom: 10px;">{{item.title}}</div>
                                </van-row>
                            </van-col>
                        </van-row>
                        <van-row v-if="item.imgList.length>0">
                            <van-col span="24">
                                <img :src="item.imgList[0]" class="bignews-img">
                            </van-col>
                        </van-row>
                        <van-row >
                            <van-col span="24">
                                <van-row>
                                    <div class="news-read" style="margin-bottom: 10px;">{{item.browseNum}}阅读</div>
                                </van-row>
                            </van-col>
                        </van-row>
                    </div>
                    <div class="more-pic-news" v-if="item.imgList.length>2" >
                        <van-row >
                            <div class="news-title-two">{{item.title}}</div>
                        </van-row>
                        <van-row>
                            <van-col span="8" >
                                <img :src="item.imgList[0]" class="news-img">
                            </van-col>
                            <van-col span="8" >
                                <img :src="item.imgList[1]" style="max-width:100%;" class="news-img">
                            </van-col>
                            <van-col span="8" >
                                <img :src="item.imgList[2]" class="news-img">
                            </van-col>
                        </van-row>
                        <van-row >
                            <div class="news-read">{{item.browseNum}}阅读</div>
                        </van-row>
                    </div>
                </van-cell>
            </van-list>

        </div>
        <div v-if="active==='news'" class="page">
            <van-tabs v-model="newsKind" @change="changeNewsKind">
                <van-tab v-for="kind in newsKindList" :key="kind.id" :title="kind.name">
                    <van-list
                            v-model="loading"
                            :finished="finished"
                            finished-text="没有更多了"
                            @load="onLoad"
                    >
                        <van-cell v-for="item in kindNewsList" :key="item" style="padding: 0;" @click="gotoNewsDetail(item.id,item.newsUrl)">
                            <div class="one-pic-news" v-if="item.imgList.length<3">
                                <van-row >
                                    <van-col span="24">
                                        <van-row>
                                            <div class="big-news-title" style="margin-bottom: 10px;">{{item.title}}</div>
                                        </van-row>
                                    </van-col>
                                </van-row>
                                <van-row v-if="item.imgList.length>0">
                                    <van-col span="24">
                                        <img :src="item.imgList[0]" class="bignews-img">
                                    </van-col>
                                </van-row>
                                <van-row >
                                    <van-col span="24">
                                        <van-row>
                                            <div class="news-read" style="margin-bottom: 10px;">{{item.browseNum}}阅读</div>
                                        </van-row>
                                    </van-col>
                                </van-row>
                            </div>
                            <div class="more-pic-news" v-if="item.imgList.length>2" >
                                <van-row >
                                    <div class="news-title-two">{{item.title}}</div>
                                </van-row>
                                <van-row>
                                    <van-col span="8" >
                                        <img :src="item.imgList[0]" class="news-img">
                                    </van-col>
                                    <van-col span="8" >
                                        <img :src="item.imgList[1]" style="max-width:100%;" class="news-img">
                                    </van-col>
                                    <van-col span="8" >
                                        <img :src="item.imgList[2]" class="news-img">
                                    </van-col>
                                </van-row>
                                <van-row >
                                    <div class="news-read">{{item.browseNum}}阅读</div>
                                </van-row>
                            </div>
                        </van-cell>
                    </van-list>
                </van-tab>
            </van-tabs>
        </div>
        <div v-if="active==='gem'">
            <img src="https://imgdc.wangxiaobao.com/1591803914499@xizang1.jpeg" class="gem-img"/>
            <div class="gem-area">
                <van-list
                        v-model="loading"
                        :finished="finished"
                        finished-text="没有更多了"
                        @load="onLoad"
                        class="gem-content"
                >
                    <van-cell v-for="item in gemList" :key="item"  class="gem-item">
                        <van-row @click="gotoGemDetail(item.id)">
                            <van-col span="5">
                                <img :src="item.pictureUrl" class="gem-item-img"/>
                            </van-col>
                            <van-col span="12">
                                <van-row class="gem-item-name">{{item.venueSubType}}</van-row>
                                <van-row class="gem-item-price">{{item.priceDesc}}</van-row>
                            </van-col>
                            <van-col span="6" offset="1" class="gem-item-action">
                                立即预定
                            </van-col>
                        </van-row>
                    </van-cell>
                </van-list>
            </div>
        </div>

        <div v-if="active==='mine'" >
            <div class="page">
                <van-row class="user-info" @click="gotoUserCenter">
                    <van-col>
                        <img src="../assets/header.png" class="user-head"/>
                    </van-col>
                    <van-col>
                        <div class="user-name">{{userInfo.username}}</div>
                        <div class="user-note">再忙也要运动</div>
                    </van-col>

                </van-row>
                <van-row type="flex" justify="center" class="jifen-info">
                    <van-col span="24" class="zhezhao-item-one" @click="gotoSign">
                        <img src="../assets/jifenzhezhao.png" class="zhezhao"/>
                        <div class="zhezhao-content">
                            <van-row class="zhazhao-name">
                                签到送积分
                            </van-row>
                            <van-row class="zhazhao-value">
                                积分：{{ userInfo.points }}
                            </van-row>
                        </div>
                    </van-col>
                    <!-- <van-col span="11" class="zhezhao-item-two" @click="gotoShare">
                        <img src="../assets/youhuizhezhao.png" class="zhezhao"/>
                        <div class="zhezhao-content">
                            <van-row class="zhazhao-name">
                                邀请得优惠券
                            </van-row>
                            <van-row class="zhazhao-value">
                                数量6
                            </van-row>
                        </div>
                    </van-col> -->
                </van-row>
                <van-row type="flex" justify="space-between" align="center" class="mine-action-item" @click="gotoOrder">
                    <van-col>
                        <van-row>
                            <van-col>
                                <img src="../assets/yuyue.png" style="width: 24px;height: 24px;" />
                            </van-col>
                            <van-col class="mine-action-name">
                                我的预约
                            </van-col>
                        </van-row>
                    </van-col>
                    <van-col>
                        <img src="../assets/icon_right.png" style="width: 12px;height: 12px;" />
                    </van-col>
                </van-row>
                <van-row class="line"></van-row>
                <!-- <van-row type="flex" justify="space-between" align="center" class="mine-action-item" @click="gotoYouhuiquan">
                    <van-col>
                        <van-row>
                            <van-col>
                                <img src="../assets/youhui.png" style="width: 24px;height: 24px;" />
                            </van-col>
                            <van-col class="mine-action-name">
                                我的优惠券
                            </van-col>
                        </van-row>
                    </van-col>
                    <van-col>
                        <img src="../assets/icon_right.png" style="width: 12px;height: 12px;" />
                    </van-col>
                </van-row>
                <van-row class="line"></van-row> -->
                <van-row type="flex" justify="space-between" align="center" class="mine-action-item" @click="gotoUserCenter">
                    <van-col>
                        <van-row>
                            <van-col>
                                <img src="../assets/phone_mine.png" style="width: 24px;height: 24px;" />
                            </van-col>
                            <van-col class="mine-action-name">
                                手机号
                            </van-col>
                        </van-row>
                    </van-col>
                    <van-col>
                        <van-col class="phone-name">
                            {{userInfo.telephone}}
                        </van-col>
                        <img src="../assets/icon_right.png" style="width: 12px;height: 12px;" />
                    </van-col>
                </van-row>
                <van-row class="line"></van-row>
            </div>

        </div>
        <van-dialog v-model="showShare" :show-confirm-button="false">
            <div class="share-area">
                <div class="share-top">
                    <div class="top-one">分享给好友</div>
                    <div class="top-two">用户注册后获得优惠券</div>
                </div>
                <div class="share-bootom">
                    <div class="bottom-one">注册时填写推荐人优惠码</div>
                    <div class="bottom-two">推荐人也可以获得优惠券</div>
                </div>
                <div class="share-action" @click="shareAction">
                    立即邀请
                </div>
            </div>
        </van-dialog>
        <van-dialog v-model="showSign" :show-confirm-button="false">
            <div class="sign-area">
                <div  class="sign-top-area">
                    <img src="../assets/signn_top1.png" class="sign-top"/>
                    <div class="sign-top-info">
                        <div class="sign-top-tip">+1</div>
                        <div class="sign-top-tip2">签到成功</div>
                        <div class="sign-top-tip3">当前积分：{{userInfo.points}}</div>
                    </div>

                </div>
                <div class="share-bootom-one">
                    <van-row type="flex" justify="space-around">
                        <van-col class="bottom-item" @click="gotoSign()">
                            <div class="bottom-item-one">+1</div>
                            <img class="bottom-item-two" src="../assets/jifen.png"/>
                        </van-col>
                        <van-col class="bottom-item">
                            <div class="bottom-item-one">+1</div>
                            <img class="bottom-item-two" src="../assets/jifen.png"/>
                        </van-col>
                        <van-col class="bottom-item">
                            <div class="bottom-item-one">+1</div>
                            <img class="bottom-item-two" src="../assets/jifen.png"/>
                        </van-col>
                        <van-col class="bottom-item">
                            <div class="bottom-item-one">+1</div>
                            <img class="bottom-item-two" src="../assets/jifen.png"/>
                        </van-col>
                    </van-row>
                    <van-row type="flex" justify="space-around">
                        <van-col class="bottom-item">
                            <div class="bottom-item-one">+1</div>
                            <img class="bottom-item-two" src="../assets/jifen.png"/>
                        </van-col>
                        <van-col class="bottom-item">
                            <div class="bottom-item-one">+1</div>
                            <img class="bottom-item-two" src="../assets/jifen.png"/>
                        </van-col>
                        <van-col class="bottom-item">
                            <div class="bottom-item-one">+1</div>
                            <img class="bottom-item-two" src="../assets/jifen.png"/>
                        </van-col>

                    </van-row>
                </div>
                <div class="share-action" @click="signAction">
                    关闭
                </div>
            </div>
        </van-dialog>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import store from "@/store/";
import { Swipe, SwipeItem } from "vant";
import { bannerList } from "@/api/api";
import { noticeList } from "@/api/api";
import { newsList } from "@/api/api";
import { kindNewsList } from "@/api/api";
import { gemList } from "@/api/api";
import { userLogin } from "@/api/api";
import { userRegister } from "@/api/api";
import { getUserInfo } from "@/api/api";
import { userSignList } from "@/api/api";
import { userSign } from "@/api/api";
import { getWxConfig } from "@/api/api";
import { Toast } from "vant";
import "vant/lib/index.css";
import wx from "weixin-js-sdk";
export default {
  name: "index",
  data() {
    return {
      code: this.$route.query.code ? this.$route.query.code : "",
      showSign: false,
      showShare: false,
      newsKind: "country",
      active: "home",
      loading: false,
      finished: true,
      bannerList: [
        {
          url: "https://imgdc.wangxiaobao.com/1591803914499@xizang1.jpeg",
        },
        {
          url: "https://imgdc.wangxiaobao.com/1591803977253@xizang2.jpeg",
        },
        {
          url: "https://imgdc.wangxiaobao.com/1591804011401@xizang3.jpeg",
        },
      ],
      noticeList: [
        {
          name: "新建篮球场开业",
        },
        {
          name: "我市新增5哥羽毛球场地",
        },
        {
          name: "越运动越健康",
        },
      ],
      funtionList: [
        {
          img: "assets/one.png",
          name: "新闻中心",
        },
        {
          img: "assets/two.png",
          name: "活动中心",
        },
        {
          img: "assets/four.png",
          name: "场馆预约",
        },
        {
          img: "assets/three.png",
          name: "健康指南",
        },
        {
          img: "assets/five.png",
          name: "我的预约",
        },
      ],
      newsList: [],
      gemList: [
        {
          img: "https://imgdc.wangxiaobao.com/1591803914499@xizang1.jpeg",
          name: "羽毛球馆",
          price: "¥10-20元／场",
        },
        {
          img: "https://imgdc.wangxiaobao.com/1591803977253@xizang2.jpeg",
          name: "篮球场",
          price: "¥80-120元／场",
        },
        {
          img: "https://imgdc.wangxiaobao.com/1591804011401@xizang3.jpeg",
          name: "乒乓球场",
          price: "¥10-20元／场",
        },
      ],
      kindNewsList: [],
      newsKindList: [],
    };
  },
  created() {
    // var s, ss;
    // var s = "a,b,c";
    // // 在每个空格字符处进行分解。
    // ss = s.split(",");
    // console.log(ss)
    // this.doLogin();

    this.getBanner();
    this.getNoticeList();
    this.getNewsList();
    this.getNewsKind();
    this.getGemList();
  },
  computed: {
    ...mapGetters(["userInfo", "openId"]),
    // userInfo () {
    //     return store.getters.userInfo
    // }
  },
  mounted() {
    // this.getWxInfo()
    // if (!this.$route.query.code){
    //     this.code = '没有获取到code'
    //     var url = "http://ivwksm.natappfree.cc"
    //     var jumpUrl = encodeURIComponent(url)
    //     window.location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx9214537705cc5158&redirect_uri="+ jumpUrl + "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect"
    // }else{
    //     Toast('获取到code');
    //     this.code = '获取到code:' + this.$route.query.code
    //     this.doLogin()
    // }
  },
  methods: {
    gotoUserCenter() {
      this.$router.push({ path: "/usercenter" });
    },
    onLoad() {},
    doWexinConfig(info) {
      let that = this;
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: info.appId, // 必填，公众号的唯一标识
        timestamp: info.timestamp + "", // 必填，生成签名的时间戳
        nonceStr: info.noncestr, // 必填，生成签名的随机串
        signature: info.signature, // 必填，签名
        jsApiList: ["chooseWXPay", "onMenuShareAppMessage"], // 必填，需要使用的JS接口列表
      });

      wx.ready(() => {
        wx.onMenuShareAppMessage({
          title: "拉萨体育文化中心", // 分享标题
          desc: "拉萨市体育场馆提前预定，在线查看", // 分享描述
          link: "http://xzty.gkzhi.com", // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: "https://imgdc.wangxiaobao.com/1591803914499@xizang1.jpeg", // 分享图标
          type: "link", // 分享类型,music、video或link，不填默认为link
          dataUrl: "", // 如果type是music或video，则要提供数据链接，默认为空
          success: function() {
            // 用户点击了分享后执行的回调函数
            Toast("分享成功，用户注册后可获得积分");
          },
          cancel: function() {
            Toast("你没有分享给朋友");
          },
        });
      });

      wx.error(function(res) {
        console.log("wx err", res);
        that.code = that.code + "微信jssdk调用失败" + JSON.stringify(res);

        //可以更新签名
      });
    },
    getWxInfo() {
      var jumpUrl = encodeURIComponent(window.location.href);
      let params = {
        url: jumpUrl,
      };
      getWxConfig(params).then((res) => {
        if (res.code == 0) {
          this.doWexinConfig(res.data);
        }
      });
    },
    doLogin() {
      let params = {
        code: this.code,
      };
      userLogin(params).then((res) => {
        if (res.code == 0) {
          localStorage.setItem("token", res.data.openId);
          // this.doRegister()
          this.getUserInfo();
        }
      });
    },
    getUserInfo() {
      getUserInfo().then((res) => {
        console.log(res);
        if (res.code == 0) {
          this.getUserSignList();
        } else if (res.code == 400001) {
          this.doRegister();
        }
      });
    },
    getUserSignList() {
      userSignList().then((res) => {
        console.log(res);
        if (res.code == 0) {
        }
      });
    },
    doRegister() {
      let params = {
        telephone: "834794792",
      };
      userRegister(params).then((res) => {
        if (res.code == 0) {
        }
      });
    },
    changeNewsKind(index) {
      this.getKindNews(index);
    },
    onTabChange(index) {
      if (index === "home") {
        this.getNewsList();
      } else if (index === "news") {
        this.getNewsKind();
      } else if (index === "gem") {
        this.getGemList();
      } else {
        store.dispatch("user/getUserByOpenId", this.openId);
      }
    },
    gotoNewsDetail(id, url) {
      if (url != null && url.length != 0) {
        window.location.href = url;
      } else {
        this.$router.push({ path: "/newsdetail?newsId=" + id });
      }
    },
    gotoGemDetail(id) {
      this.$router.push({ path: "/gemdetail?gemId=" + id });
    },
    gotoNoticeCenter() {
      this.$router.push({ path: "/noticecenter" });
    },
    gotoPage(index) {
      if (index == 0) {
        this.active = "news";
      } else if (index == 1) {
        this.$router.push({ path: "/activitycenter" });
      } else if (index == 2) {
        this.$router.push({ path: "/gemlist" });
      } else if (index == 3) {
        this.$router.push({ path: "/healthcenter" });
      } else {
        this.$router.push({ path: "/myorder" });
      }
    },
    getBanner() {
      bannerList().then((res) => {
        if (res.code == 0) {
          console.log(res);
          this.bannerList = res.data.list;
        }
      });
    },
    getNoticeList() {
      noticeList().then((res) => {
        if (res.code == 0) {
          this.noticeList = res.data.list;
        }
      });
    },
    getNewsList() {
      newsList().then((res) => {
        if (res.code == 0) {
          let list = [];
          for (let i = 0; i < res.data.list.length; i++) {
            var info = res.data.list[i];
            let imgList = [];
            if (info.pictureUrl && info.pictureUrl.length > 0) {
              if (info.pictureUrl.indexOf(",") !== -1) {
                imgList = info.pictureUrl.split(",");
              } else {
                imgList.push(info.pictureUrl);
              }
            }
            info.imgList = imgList;
            list.push(info);
          }
          this.newsList = list;
        }
      });
    },
    getNewsKind() {
      kindNewsList().then((res) => {
        if (res.code == 0) {
          this.newsKindList = res.data;
          this.getKindNews(0);
        }
      });
    },
    getKindNews(index) {
      let params = {
        channelId: this.newsKindList[index].id,
      };
      newsList(params).then((res) => {
        if (res.code == 0) {
          let list = [];
          for (let i = 0; i < res.data.list.length; i++) {
            var info = res.data.list[i];
            let imgList = [];
            if (info.pictureUrl && info.pictureUrl.length > 0) {
              if (info.pictureUrl.indexOf(",") !== -1) {
                imgList = info.pictureUrl.split(",");
              } else {
                imgList.push(info.pictureUrl);
              }
            }
            info.imgList = imgList;
            list.push(info);
          }
          this.kindNewsList = list;
        }
      });
    },
    getGemList() {
      gemList().then((res) => {
        if (res.code == 0) {
          this.gemList = res.data.list;
        }
      });
    },
    gotoOrder() {
      this.$router.push({ path: "/myorder" });
    },
    gotoYouhuiquan() {
      this.$router.push({ path: "/youhuiquan" });
    },
    shareAction() {
      this.getWxInfo();
      // Toast('邀请成功，用户注册后可获得积分');
      this.showShare = false;
    },
    gotoShare() {
      this.showShare = true;
    },
    gotoSign() {
      userSign().then((res) => {
        if (res.code === 0) {
          this.$store.dispatch("user/getUserByOpenId", this.openId);
          this.showSign = true;
        } else {
          this.$toast.fail("今日已签到");
        }
      });
    },
    signAction() {
      this.showSign = false;
    },
  },
};
</script>

<style scoped>
.page {
  margin-right: 16px;
  margin-left: 16px;
}
.banner-area {
  margin-top: 18px;
  margin-bottom: 12px;
}
.banner-image {
  width: 100%;
  height: 160px;
  border-radius: 20px;
}
.font-12 {
  font-size: 12px;
}
.color-black {
  color: #282b31;
}
.color-gray {
  color: #999ea8;
}
.font-weight {
  font-family: PingFangTC-Regular, PingFangTC;
  font-weight: 400;
  line-height: 41px;
}
.notice-area {
  margin-bottom: 12px;
  height: 41px;
  background: rgba(103, 178, 255, 0.2);
  box-shadow: 0px 2px 8px 0px rgba(255, 193, 7, 0.2);
  border-radius: 12px;
}
.news-top {
  width: 100%;
  margin-top: 40px;
  height: 24px;
}
.news_left {
  width: 3px;
  height: 14px;
  margin-top: 5px;
  background: rgba(49, 112, 255, 1);
  margin-right: 5px;
}
.news_text {
  font-size: 17px;
  font-family: PingFangTC-Semibold, PingFangTC;
  font-weight: 600;
  color: rgba(40, 43, 49, 1);
  line-height: 24px;
}
.one-pic-news {
  width: 100%;
  height: auto;
  padding-top: 24px;
  padding-bottom: 24px;
}
.big-news-title {
  height: auto;
  font-size: 17px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(40, 43, 49, 1);
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.news-title {
  height: 72px;
  font-size: 17px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(40, 43, 49, 1);
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
.news-title-two {
  height: 48px;
  font-size: 17px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(40, 43, 49, 1);
  line-height: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  margin-bottom: 12px;
}
.news-read {
  font-size: 12px;
  font-family: PingFangTC-Regular, PingFangTC;
  font-weight: 400;
  color: rgba(153, 158, 168, 1);
  line-height: 17px;
  margin-top: 12px;
}
.news-img {
  width: 110px;
  height: 89px;
  border-radius: 10px;
}
.bignews-img {
  width: 100%;
  height: 198px;
  border-radius: 10px;
}
.more-pic-news {
  width: 100%;
  height: 178px;
  padding-top: 24px;
  padding-bottom: 24px;
}
.gem-img {
  width: 100%;
  height: 258px;
  position: absolute;
  top: 0;
  left: 0;
}
.gem-area {
  width: 100%;
  height: auto;
  background: #fff;
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  top: 238px;
  left: 0;
  position: absolute;
}
.user-info {
  height: 70px;
  padding-top: 25px;
  padding-bottom: 30px;
  background: #fff;
}
.user-head {
  width: 70px;
  height: 70px;
  margin-right: 12px;
  border-radius: 50%;
}
.user-name {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(40, 43, 49, 1);
  line-height: 28px;
  margin-bottom: 12px;
}
.user-note {
  font-size: 12px;
  font-family: PingFangTC-Regular, PingFangTC;
  font-weight: 400;
  color: rgba(153, 158, 168, 1);
  line-height: 17px;
}
.user-jifen {
  width: 167px;
  height: 89px;
  background: rgba(255, 129, 80, 1);
  box-shadow: 0px 2px 8px 0px rgba(255, 129, 80, 0.2);
  border-radius: 12px;
}
.gem-item {
  width: 100%;
  height: 74px;
  background: #00000000;
}
.gem-item-img {
  width: 52px;
  height: 52px;
  border-radius: 5px;
  margin-right: 12px;
}
.gem-item-name {
  font-size: 17px;
  font-family: PingFangTC-Regular, PingFangTC;
  font-weight: 400;
  color: rgba(40, 43, 49, 1);
  line-height: 24px;
  margin-bottom: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
.gem-item-price {
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(103, 108, 117, 1);
  line-height: 21px;
}
.gem-item-action {
  width: 72px;
  height: 33px;
  background: rgba(255, 129, 80, 1);
  box-shadow: 0px 42px 8px 0px rgba(255, 129, 80, 0.2);
  border-radius: 25px;
  margin-top: 9.5px;
  text-align: center;
  font-size: 12px;
  font-family: PingFangTC-Semibold, PingFangTC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 33px;
}
.zhezhao {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.zhezhao-content {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
}
.zhezhao-item-one {
  height: 89px;
  background: rgba(255, 129, 80, 1);
  box-shadow: 0px 2px 8px 0px rgba(255, 129, 80, 0.2);
  border-radius: 12px;
  position: relative;
}
.zhezhao-item-two {
  height: 89px;
  background: rgba(255, 193, 7, 1);
  box-shadow: 0px 2px 8px 0px rgba(255, 129, 80, 0.2);
  border-radius: 12px;
  position: relative;
}
.zhazhao-name {
  margin-top: 20px;
  margin-left: 16px;
  margin-bottom: 8px;
  font-size: 17px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 24px;
}
.zhazhao-value {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 17px;
  margin-left: 16px;
}
.jifen-info {
  margin-bottom: 20px;
}
.phone-name {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 158, 168, 1);
  line-height: 24px;
  margin-right: 5px;
}
.mine-action-name {
  font-size: 17px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(40, 43, 49, 1);
  line-height: 24px;
}
.mine-action-item {
  width: 100%;
  height: 64px;
}
.fuc-name {
  font-size: 12px;
  font-family: PingFangTC-Regular, PingFangTC;
  font-weight: 400;
  color: rgba(103, 108, 117, 1);
  line-height: 17px;
  text-align: center;
}
.minepage {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(245, 245, 245, 1);
}
.line {
  width: 100%;
  height: 1px;
  background: rgba(245, 245, 245, 1);
}
.share-area {
  width: 325px;
  height: 307px;
  background: rgba(255, 255, 255, 1);
  border-radius: 16px;
}
.share-top {
  width: 325px;
  height: 93px;
  background: rgba(255, 193, 7, 1);
  padding-top: 32px;
}
.top-one {
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 28px;
  margin-bottom: 12px;
  text-align: center;
}
.top-two {
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 21px;
  text-align: center;
}
.share-bootom {
  margin-top: 32px;
}
.bottom-one {
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(103, 108, 117, 1);
  line-height: 21px;
  text-align: center;
}
.bottom-two {
  font-size: 15px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(103, 108, 117, 1);
  line-height: 21px;
  text-align: center;
}
.share-action {
  width: 201px;
  height: 48px;
  background: rgba(255, 193, 7, 1);
  box-shadow: 0px 2px 8px 0px rgba(255, 193, 7, 0.2);
  border-radius: 25px;
  margin: 0 auto;
  margin-top: 32px;
  font-size: 17px;
  font-family: PingFangTC-Semibold, PingFangTC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 48px;
  text-align: center;
}
.sign-area {
  width: 325px;
  height: 463px;
  background: rgba(255, 255, 255, 1);
  border-radius: 16px;
}
.sign-top-area {
  width: 325px;
  height: 186px;
  position: relative;
}
.sign-top {
  position: absolute;
  width: 325px;
  height: 186px;
  top: 0;
  left: 0;
}
.sign-top-info {
  position: absolute;
  width: 325px;
  height: 186px;
  top: 0;
  left: 0;
}
.sign-top-tip {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  margin: 0 auto;
  margin-top: 20px;
  font-size: 20px;
  font-family: Helvetica-Bold, Helvetica;
  font-weight: bold;
  color: rgba(255, 120, 64, 1);
  line-height: 64px;
  text-align: center;
  background: #ffffff;
}
.sign-top-tip2 {
  font-size: 17px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 24px;
  margin-top: 14px;
  text-align: center;
}
.sign-top-tip3 {
  font-size: 15px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: rgba(255, 255, 255, 1);
  line-height: 21px;
  margin-top: 2px;
  text-align: center;
}
.share-bootom-one {
}
.bottom-item {
  width: 56px;
  height: 67px;
  background: rgba(242, 241, 240, 1);
  border-radius: 8px;
  padding-top: 6px;
  margin-bottom: 5px;
}
.bottom-item-one {
  font-size: 17px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 120, 64, 1);
  line-height: 24px;
  text-align: center;
  margin-bottom: 4px;
}
.bottom-item-two {
  width: 32px;
  height: 32px;
  margin: 0 auto;
  display: block;
}
</style>
